import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { AppPageComponent, AppBarComponent, AppBarCloseAction, AppBarTitleComponent, AppBarContactComponent, SyncGuardHelper } from "common";
import { AccountSetupComponent } from "./features/account-setup/account-setup.component";
import { AuthGuard } from "../auth/infrastructure/auth.guard";
import { AccountSetupGuard } from "./guards/account-setup.guard";
import { VerifyIdentityComponent } from "./features/verify-identity/verify-identity.component";
import { VerifyIdentityGuard } from "./guards/verify-identity.guard";
import { VerifyIdentityResultComponent } from "./features/verify-identity-result/verify-identity-result.component";

const routes: Routes = [
  {
    path: 'account/setup',
    pathMatch: 'full',
    component: AppPageComponent,
    canActivate: [AuthGuard],
    data: {
      appBar: {
        closeAction: AppBarCloseAction.HOME,
        expandable: false,
        logoHidden: true
      },
      appBarTitle: {
        content: 'What happens next'
      }
    },
    children: [
      {
        path: '',
        outlet: 'app-bar',
        component: AppBarComponent,
        children: [
          {
            path: '',
            outlet: 'title',
            component: AppBarTitleComponent,
          },
          {
            path: '',
            outlet: 'right',
            component: AppBarContactComponent
          }
        ]
      },
      {
        path: '',
        component: AccountSetupComponent,
        canActivate: [AccountSetupGuard]
      }
    ]
  }, {
    path: 'account/setup/verify-identity',
    component: AppPageComponent,
    canActivate: [AuthGuard],
    data: {
      appBar: {
        closeAction: AppBarCloseAction.HOME,
        expandable: false,
        logoHidden: true,
      },
      appBarTitle: {
        content: 'Account setup'
      }
    },
    children: [
      {
        path: '',
        outlet: 'app-bar',
        component: AppBarComponent,
        children: [
          {
            path: '',
            outlet: 'title',
            component: AppBarTitleComponent
          },
          {
            path: '',
            outlet: 'right',
            component: AppBarContactComponent
          }
        ]
      },
      {
        path: '',
        component: VerifyIdentityComponent,
        canActivate: [SyncGuardHelper],
        data: {
          syncGuards: [
            AccountSetupGuard,
            VerifyIdentityGuard,
          ]
        },
      }
    ]
  },
  {
    path: 'account/setup/verify-identity-result',
    component: AppPageComponent,
    canActivate: [AuthGuard],
    data: {
      appBar: {
        closeAction: AppBarCloseAction.SIGN_OUT,
        expandable: false,
        logoHidden: true,
      },
      appBarTitle: {
        content: 'Account setup'
      }
    },
    children: [
      {
        path: '',
        outlet: 'app-bar',
        component: AppBarComponent,
        children: [
          {
            path: '',
            outlet: 'title',
            component: AppBarTitleComponent
          },
          {
            path: '',
            outlet: 'right',
            component: AppBarContactComponent
          }
        ]
      },
      {
        path: '',
        component: VerifyIdentityResultComponent,
      }
    ]
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class IdentityVerificationRoutingModule { }
